export type LegalDocKind = 'legal' | 'privacy' | 'terms' | 'data-deletion';

export type LegalDocMeta = {
  kind: LegalDocKind;
  path: string;
  tag: string;
  title: string;
  readTime: string;
  short: string; // short tab label
  kicker: string; // small tab prefix
};

export const LEGAL_DOCS: ReadonlyArray<LegalDocMeta> = [
  {
    kind: 'legal',
    path: '/mentions-legales',
    tag: 'Document officiel',
    title: 'Mentions légales',
    readTime: '3 min',
    short: 'Mentions légales',
    kicker: "Document 1 · L'éditeur",
  },
  {
    kind: 'privacy',
    path: '/politique-confidentialite',
    tag: 'Confidentialité · OHADA',
    title: 'Politique de confidentialité',
    readTime: '6 min',
    short: 'Confidentialité',
    kicker: 'Document 2 · Les données',
  },
  {
    kind: 'terms',
    path: '/conditions-utilisation',
    tag: "CGU · Contrat d'usage",
    title: "Conditions générales d'utilisation",
    readTime: '8 min',
    short: 'Conditions générales',
    kicker: "Document 3 · L'usage",
  },
  {
    kind: 'data-deletion',
    path: '/suppression-donnees',
    tag: 'Suppression des données',
    title: 'Suppression de vos données',
    readTime: '2 min',
    short: 'Suppression données',
    kicker: 'Document 4 · La suppression',
  },
];

export function docMeta(kind: LegalDocKind): LegalDocMeta {
  return LEGAL_DOCS.find((d) => d.kind === kind) ?? (LEGAL_DOCS[0] as LegalDocMeta);
}
